<template>
  <button class="custom-btn btn-8"><span><slot/></span></button>
</template>

<script>
export default {
  name: "Bt404",
  props: {
    href: {
      type: String,
      default: "https://mixitweb.com",
    }
  }
}
</script>

<style scoped>

.custom-btn {
  width: 130px;
  height: 40px;
  color: var(--light-white);
  border-radius: 5px;
  padding: 10px 25px;
  font-family: 'Lato', sans-serif;
  font-weight: 500;
  background: transparent;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  display: inline-block;
  box-shadow: inset 2px 2px 2px 0px var(--white), 7px 7px 20px 0px var(--dark), 4px 4px 5px 0px var(--primary-btn);
  outline: none;
}

/* 8 */
.btn-8 {
  background-color: var(--primary-btn);
  background-image: linear-gradient(315deg, var(--primary-btn) 0%, var(--light-indigo) 74%);
  line-height: 42px;
  padding: 0;
  border: none;
}
.btn-8 span {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
}
.btn-8:before,
.btn-8:after {
  position: absolute;
  content: "";
  right: 0;
  bottom: 0;
  background: var(--light-indigo);

  transition: all 0.3s ease;
}
.btn-8:before{
  height: 0%;
  width: 2px;
}
.btn-8:after {
  width: 0%;
  height: 2px;
}
.btn-8:hover:before {
  height: 100%;
}
.btn-8:hover:after {
  width: 100%;
}
.btn-8:hover{
  background: transparent;
}
.btn-8 span:hover{
  color: var(--light-indigo);
}
.btn-8 span:before,
.btn-8 span:after {
  position: absolute;
  content: "";
  left: 0;
  top: 0;
  background: var(--light-indigo);

  transition: all 0.3s ease;
}
.btn-8 span:before {
  width: 2px;
  height: 0%;
}
.btn-8 span:after {
  height: 2px;
  width: 0%;
}
.btn-8 span:hover:before {
  height: 100%;
}
.btn-8 span:hover:after {
  width: 100%;
}
</style>